import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'antd';

const KeywordsAlert = ({ display, onProceed, onClose }) => {
  if (!display) return null;

  return (
    <Alert
      type='warning'
      message={
        "These custom keyword(s) do not match any of the contact's activities. Please try again or click proceed to use account keywords."
      }
      closable={false}
      showIcon
      onClose={onClose}
      action={
        <Button size='middle' style={{ width: '100%' }} onClick={onProceed}>
          Proceed
        </Button>
      }
    />
  );
};

KeywordsAlert.propTypes = {
  display: PropTypes.bool.isRequired,
  onProceed: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default KeywordsAlert;
